module.exports = __webpack_public_path__ + "img/icon-zzyl.e1de0586.png";